module.exports = __webpack_public_path__ + "offline.json?ddabfceb83676c5602932cc21c441634";


//////////////////
// WEBPACK FOOTER
// ./client/static/offline.json
// module id = 110
// module chunks = 0